import { render, staticRenderFns } from "./VehiculeSinistres.vue?vue&type=template&id=3a7f63c0&scoped=true&"
import script from "./VehiculeSinistres.vue?vue&type=script&lang=js&"
export * from "./VehiculeSinistres.vue?vue&type=script&lang=js&"
import style0 from "./VehiculeSinistres.vue?vue&type=style&index=0&id=3a7f63c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7f63c0",
  null
  
)

export default component.exports